// extracted by mini-css-extract-plugin
export default {"cellBox":"FobQhclF3JVVulWMoCJT"};